import AppointmentAttendanceStatus from './AppointmentAttendanceStatus';

export default AppointmentAttendanceStatus;
